/*global http pagination searchFilter*/
const search = {
	el: {
		body: document.body,
		search: document.querySelector('.search'),
		nav: document.querySelector('.nav'),
		form: document.querySelector('.general'),
		filterFormModal: document.querySelectorAll('.js-filter'),
		searchOpen: document.querySelectorAll('.js-open-search'),
		searchClose: document.querySelector('.js-close-search'),
		searchHighlights: document.querySelector('.search__highlights')
	},

	vars: {
		timer: '',
		currentPage: 1,
		endpoint: `${document.querySelector('.general').getAttribute('action')}/`
	},

	fxHideHighlights() {
		const search = this.el.search

		this.el.searchHighlights && this.el.searchHighlights.removeAttribute('style')

		search.querySelector('.search-results').classList.remove('has-value')
		search.querySelector('.filter-search__text').classList.remove('has-value')
		search.querySelector('.pagination').classList.remove('has-value')
	},

	fxClearSearch() {
		const search = this.el.search,
			clearButton = search.querySelector('.js-search-clean'),
			input = search.querySelector('.js-autocomplete'),
			searchResults = search.querySelector('.search-results'),
			searchResultsContent = searchResults.innerHTML

		clearButton.addEventListener('click', e => {
			e.currentTarget.removeAttribute('style')
			input.value = ''
			this.el.searchHighlights && this.fxHideHighlights()
			searchResults.innerHTML = searchResultsContent
			this.vars.currentPage = 1
		})
	},

	//pagination
	fxGetResultsPaginationButton() {
		if (!pagination.el.paginationButtonPrev || !pagination.el.paginationButtonNext) return
		pagination.el.paginationButtonPrev.forEach(el => el.addEventListener('click', e => {
			const search = e.target.closest('.search')

			if (search) {
				this.vars.currentPage--
				pagination.fxNavigationHelper(this.vars.endpoint, '.search-results', e.target.nextElementSibling, this.vars.currentPage)
			}
		}))

		pagination.el.paginationButtonNext.forEach(el => el.addEventListener('click', e => {
			const search = e.target.closest('.search')

			if (search) {
				this.vars.currentPage++
				pagination.fxNavigationHelper(this.vars.endpoint, '.search-results', e.target.previousElementSibling, this.vars.currentPage)
			}
		}))
	},

	fxGetResultsPaginationItem() {
		const input = this.el.search.querySelector('.js-autocomplete')

		document.addEventListener('click', e => {
			if (e.target && e.target.classList.contains('pagination__item') && e.target.closest('.search')) {
				const paginationItem = e.target,
					paginationAllItems = paginationItem.closest('.pagination__list').querySelectorAll('.pagination__item'),
					page = Number(paginationItem.querySelector('button').textContent),
					paginationList = paginationItem.parentElement

				paginationAllItems.forEach(el => el.classList.remove('is-active'))
				paginationItem.classList.add('is-active')

				const callback = response => {
					pagination.fxPaginationHelper(response, paginationList)
					this.fxSearchCallback(response, page)
				}

				http.fxGet(`${this.vars.endpoint.substring(0, this.vars.endpoint.lastIndexOf('/') + 1)}${input.value}/${page}`, callback).then(response => {
					this.vars.currentPage = response.data.pagination.filter(el => {
						if (el.currentPage) return el
					})[0].page
					pagination.fxPaginationItemHelper(response, paginationList, this.vars.currentPage)

				})
			}
		})
	},

	fxGetResultsOnEvents() {
		const input = this.el.search.querySelector('.js-autocomplete')

		input.addEventListener('keydown', e => {
			if (e.key === 'Enter') {
				e.preventDefault()
				if (input.value.length >= 3)
					this.fxSearch(input.value)
			}
		})

		this.el.search.querySelector('.js-search-filter').addEventListener('click', e => {
			e.preventDefault()
			this.fxSearch(input.value)
		})
	},

	fxAutocomplete() {
		const search = this.el.search,
			clearButton = search.querySelector('.js-search-clean'),
			input = search.querySelector('.js-autocomplete'),
			searchResults = search.querySelector('.search-results'),
			searchResultsContent = searchResults.innerHTML

		input.addEventListener('input', () => {
			if (input.value.length >= 3) {
				this.el.searchHighlights ? this.el.searchHighlights.style.display = 'none' : ''
				input.nextElementSibling.style.display = 'block'

				clearTimeout(this.vars.timer)

				this.vars.timer = setTimeout(() => {
					this.fxSearch(input.value)
					search.querySelector('.search-results').classList.add('has-value')
					search.querySelector('.filter-search__text').classList.add('has-value')
					search.querySelector('.pagination').classList.add('has-value')
				}, 1000)
			}
			else {
				clearButton.removeAttribute('style')
				this.el.searchHighlights && this.fxHideHighlights()
				this.vars.currentPage = 1

				if (input.value.length === 0) {
					searchResults.innerHTML = searchResultsContent
				}
			}
		})
	},

	fxSearchCallback(response, page) {
		const searchContainer = this.el.search,
			noResults = this.el.form.dataset.msgNoResults,
			paginationList = searchContainer.querySelector('.pagination__list'),
			data = response.data

		//prevent duplicate push
		searchContainer.querySelector('.search-results').innerHTML = ''

		//numberOfResults
		searchContainer.querySelector('.js-total-results').textContent = data.numberOfResults

		if (data.results.length === 0) {
			searchContainer.querySelector('.pagination').style.display = 'none'
			searchContainer.querySelector('.search-results').innerHTML = noResults
		}

		else {
			//pagination load
			if (page === undefined) {
				pagination.fxPaginationHelper(response, paginationList)
				if (data.pagination.length > pagination.vars.maxPaginationItem)
					paginationList.querySelectorAll(`.pagination__item:nth-of-type(n+${pagination.vars.maxPaginationItem+1}`).forEach(el => el.classList.add('is-hidden'))
			}

			data.results.forEach(el => {
				searchContainer.querySelector('.pagination').removeAttribute('style')
				searchContainer.querySelector('.search-results').innerHTML +=
					`
						<article class="search-results__article">
							<h2 class="search-results__heading gamma">${el.title}</h2>
							<h3 class="search-results__posheading">${el.description}</h3>
							<a class="search-results__link" href="${el.link.url}" title="${el.link.caption} ${el.title}">
								${el.link.caption}
								<svg class="button-icon-relative" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
									<path d="M14.5 8H17l3 4-3 4h-2.5l3-4-3-4z" fill-rule="evenodd" fill="#2D3134"></path>
									<path class="arrow-hovered" d="M18 13H4v-2h14v2z" fill-rule="evenodd" fill="#2D3134"></path>
								</svg>
							</a>
						</article>
					`
			})
		}
		searchContainer.querySelector('.js-autocomplete').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
	},

	fxSearch(term) {
		const query = `${term}/1`

		const callback = response => this.fxSearchCallback(response)

		http.fxGet(`${this.vars.endpoint}${query}`, callback)
	},

	fxToggleModal() {
		const search = this.el.search

		if (!this.el.searchOpen) return

		this.el.searchOpen.forEach(el => el.addEventListener('click', () => {
			this.el.searchHighlights && this.el.searchHighlights.removeAttribute('style')
			search.classList.add('is-search-open')
			this.el.body.classList.add('no-scroll-hidden')
			this.el.nav.classList.remove('is-nav-open')
		}))

		if (!this.el.searchClose) return

		this.el.searchClose.addEventListener('click', e => {
			e.preventDefault()
			search.classList.remove('is-search-open')
			this.el.body.classList.remove('no-scroll-hidden')
			search.querySelector('.js-search-clean').removeAttribute('style')
			search.querySelector('.js-autocomplete').value = ''
			search.querySelector('.search-results').classList.remove('has-value')
			search.querySelector('.filter-search__text').classList.remove('has-value')
			search.querySelector('.pagination').classList.remove('has-value')
			this.el.filterFormModal.forEach(el => searchFilter.fxFilterResults(el))
		})
	},

	init() {
		this.fxAutocomplete()
		this.fxClearSearch()
		this.fxGetResultsOnEvents()
		this.fxGetResultsPaginationButton()
		this.fxGetResultsPaginationItem()
		this.fxToggleModal()
	}

}

search.init()